import { Flex, Typography } from 'antd';

import useHirePortContext from '@/hooks/useHirePortContext';
import { SPACE_LG, SPACE_MD, SPACE_SM } from '@/theme/buildAntdTheme';
import { PageTitle } from '@/UI/typography';

import { NavSiderToggle } from './NavSiderToggle';

import type React from 'react';

interface HeaderProps extends React.ComponentProps<typeof Flex> {
  title?: string;
  subtitle?: React.ReactNode;
  mobile?: boolean;
  hideOnMobile?: boolean;
}

const Header = ({
  children,
  title,
  subtitle,
  mobile,
  hideOnMobile,
  ...rest
}: HeaderProps) => {
  const { renderPageHeader } = useHirePortContext();

  if (!renderPageHeader) {
    return null;
  }

  return (
    <Flex
      component="header"
      wrap="wrap"
      align="center"
      justify="space-between"
      style={{
        padding: mobile ? SPACE_MD : `${SPACE_LG}px 0`,
        ...(hideOnMobile ? { display: 'none' } : {}),
      }}
      {...rest}
    >
      {title && (
        <Flex wrap align="center" gap={SPACE_SM}>
          <NavSiderToggle />
          <PageTitle>{title}</PageTitle>
          {subtitle ? (
            <Typography.Text type="secondary">{subtitle}</Typography.Text>
          ) : null}
        </Flex>
      )}
      {children}
    </Flex>
  );
};

export default Header;
